import { SubAccount } from "../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";
import { MenuItem } from "../../../../../Wrap/Models/Domains/Menu/MenuItem";
import { PensionSubAccountSettings } from "../../../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { Contents } from "../../../Resoures/Contents";
import { IParameterModel } from "../IParameterModel";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { PensionArrangement } from "../../../../../Wrap/Models/Models/Account/PensionArrangement";
import { PensionArrangementType } from "../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";

export class MenuItemsHelper {
    public static getConditionalMenuItems(
        pensionSubAccountSettings: PensionSubAccountSettings,
        pensionArrangementDetails: Array<PensionArrangement>,
        queryParameter: IParameterModel,
        nprSubAccount: SubAccount
    ) {
        const menuItems: MenuItem[] = [];
        const flexiArrangments = pensionArrangementDetails.filter((x) => x.Type == PensionArrangementType.Fad);
        const cappedArrangments = pensionArrangementDetails.filter((x) => x.Type == PensionArrangementType.Capped);

        if (pensionSubAccountSettings) {
            if (checkPermission(UserClaim.AdviserPortalTPBAndEditIncomeDrawdownReadWrite)) //Keep same judgement condition with ThreeDot action list in account Summary page
            {
                menuItems.push({ MenuCaption: "Take pension benefits", Url: "", SubMenu: null });
            }
            if (checkPermission(UserClaim.AdviserPortalITFCReadWrite)) {
                menuItems.push({ MenuCaption: "Immediate tax-free lump sum", Url: "", SubMenu: null });
            }
            if (
                pensionSubAccountSettings.CanEditIncome &&
                pensionSubAccountSettings.CanEditRegularCrystallisation &&
                !pensionSubAccountSettings.HasInProgressDrawdownWizard &&
                checkPermission(UserClaim.AdviserPortalTPBAndEditIncomeDrawdownReadWrite)
            ) {
                menuItems.push({ MenuCaption: "Edit income drawdown", Url: "", SubMenu: null });
            }
            if (
                pensionSubAccountSettings.CanEditRegularCrystallisation &&
                checkPermission(UserClaim.AdviserPortalCancelRegularCrystalisationReadWrite)
            ) {
                menuItems.push({
                    MenuCaption: "Cancel tailored drawdown",
                    Url: `/wpadviser/en-gb/dashboard/home/main/client/cancel-regular-crystallisation/review?&claccountid=${queryParameter.clAccountId}&hierarchyid=${queryParameter.hierarchyId}&subaccounthierarchyid=${nprSubAccount.HierarchyId}`,
                    SubMenu: null,
                });
            }
            if (
                pensionSubAccountSettings.GadReviewEnabled &&
                pensionSubAccountSettings.GadReviewEnabledArrangementIds?.length > 0 &&
                checkPermission(UserClaim.AdviserPortalGADReviewReadWrite)
            ) {
                pensionSubAccountSettings.GadReviewEnabledArrangementIds.forEach((arrangementId) => {
                    menuItems.push({
                        MenuCaption: `GAD review (${arrangementId})`,
                        Url: `/wpadviser/en-gb/dashboard/home/main/client/gad-review/income-payment?claccountid=${queryParameter.clAccountId}&hierarchyid=${queryParameter.hierarchyId}&subaccounthierarchyid=${nprSubAccount.HierarchyId}&arrangementid=${arrangementId}`,
                        SubMenu: null,
                    });
                });
            }
            if (
                nprSubAccount.SubAccountType != SubAccountType.JuniorSipp &&
                checkPermission(UserClaim.AdviserPortalUpdateLTAReadWrite)
            ) {
                menuItems.push({
                    MenuCaption: "Update Allowance Details",
                    Url: `/wpadviser/en-gb/dashboard/home/main/client/update-lifetime-allowance/update-lifetime-allowance-detail?customerId=${queryParameter.customerId}&hierarchyid=${queryParameter.hierarchyId}`,
                    SubMenu: null,
                });
            }
            if (
                pensionSubAccountSettings.CanConvertToFlexi &&
                checkPermission(UserClaim.AdviserPortalConvertCappedToFlexiReadWrite)
            ) {
                menuItems.push({
                    MenuCaption: "Convert Capped to Flexible Drawdown",
                    Url: `/wpadviser/en-gb/dashboard/home/main/client/convert-capped-to-flexi/select-arrangement?hierarchyid=${queryParameter.hierarchyId}&subaccounthierarchyid=${nprSubAccount.HierarchyId}&claccountid=${queryParameter.clAccountId}`,
                    SubMenu: null,
                });
            }
            if (
                pensionSubAccountSettings.CanEditIncome &&
                (cappedArrangments?.length > 0 || flexiArrangments?.length > 0)
            ) {
                if (checkPermission(UserClaim.AdviserPortalOneoffIncomePaymentReadWrite)) {
                    menuItems.push({ MenuCaption: "One-off income payment", Url: "", SubMenu: null });
                }
            }

            if (pensionSubAccountSettings.CanEditIncome &&
                (cappedArrangments?.length > 0 || flexiArrangments?.length > 0)
            ) {
                if (checkPermission(UserClaim.AdviserPortalEditIncomePaymentsReadWrite)) {
                    menuItems.push({
                        MenuCaption: "Edit income payments",
                        Url: `/wpadviser/en-gb/dashboard/home/main/${Contents.URLMap.client}/${Contents.URLMap.editIncomeWithdrawals}/${Contents.URLMap.incomePayment}?customerId=${queryParameter.customerId}&claccountid=${queryParameter.clAccountId}&hierarchyid=${queryParameter.hierarchyId}&subaccounthierarchyid=${nprSubAccount.HierarchyId}`,
                        SubMenu: null,
                    });
                }
            }
        }
        if (checkPermission(UserClaim.AdviserPortalPPToSIPPAndISAReadWrite)) {
            menuItems.push({ MenuCaption: "PP to S&S ISA", Url: "", SubMenu: null });
        }

        return menuItems;
    }
}
